module.exports = __webpack_public_path__ + "img/landing_page.abd5754a.png";